<div class="table-container" [style.width]="width" [style.height]="height">
  @if (loading) {
  <div class="table-loading-shade">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
  }

  <div class="mat-table-wrapper">
    <table
      mat-table
      [dataSource]="dataSource"
      [class.sticky-header]="stickyHeader"
      [class.sticky-footer]="stickyFooter"
      matSort
      (matSortChange)="onSortChange($event)"
      (click)="onRowClick($event)"
      class="mat-elevation-z2"
    >
      <!-- Checkbox Column -->
      @if (selectable) {
      <ng-container matColumnDef="select">
        <th
          mat-header-cell
          *matHeaderCellDef
          [class.sticky-header]="stickyHeader"
        >
          <mat-checkbox
            (change)="toggleAllRows()"
            [checked]="isAllSelected()"
            [indeterminate]="selectedRows.size > 0 && !isAllSelected()"
            [color]="'primary'"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" [class.sticky-footer]="stickyFooter">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="onSelectionChange(row)"
            [checked]="isRowSelected(row)"
            [color]="'primary'"
          >
          </mat-checkbox>
        </td>
      </ng-container>
      }

      <!-- Data Columns -->
      @for (column of columns; track column.name) {
      <ng-container [matColumnDef]="column.name">
        <th
          mat-header-cell
          *matHeaderCellDef
          [class.sticky-header]="stickyHeader"
          [style.width]="getColumnWidth(column)"
          [style.text-align]="getColumnAlign(column)"
          mat-sort-header
          [disabled]="!column.sortable"
        >
          {{ column.header }}
        </th>

        <td
          mat-cell
          *matCellDef="let row"
          [class.sticky-footer]="stickyFooter"
          [style.text-align]="getColumnAlign(column)"
          [matTooltip]="column.tooltip"
          [matTooltipDisabled]="!column.tooltip"
        >
          @if (column.cellTemplate) {
          <ng-container
            [ngTemplateOutlet]="column.cellTemplate"
            [ngTemplateOutletContext]="{
              $implicit: row,
              row: row,
              column: column
            }"
          >
          </ng-container>
          } @else { @if (getColumnType(column) === 'text') { @if (column.name
          === 'coordinates') {
          <span class="coordinate-cell">
            <span class="coordinate-values" style="white-space: pre-line">{{
              getCellValue(row, column)
            }}</span>
            <mat-icon class="location-icon">location_on</mat-icon>
          </span>
          } @else if (column.name === 'duration') {
          <span [class]="row.durationClass">{{
            getCellValue(row, column)
          }}</span>
          } @else {
          <span [class]="column.customClass" style="white-space: pre-line">{{
            getCellValue(row, column)
          }}</span>
          } } @if (getColumnType(column) === 'number') {
          <span>{{ getCellValue(row, column) | number }}</span>
          } @if (getColumnType(column) === 'date') {
          <span>{{ getCellValue(row, column) | date }}</span>
          } @if (getColumnType(column) === 'boolean') {
          <mat-icon
            [ngStyle]="{
              color: getCellValue(row, column) ? '#16a34a' : '#e53935'
            }"
            [matTooltip]="getCellValue(row, column) ? 'Active' : 'Inactive'"
          >
            {{ getCellValue(row, column) ? "check_circle" : "cancel" }}
          </mat-icon>
          } @if (getColumnType(column) === 'icon') {
          <mat-icon [color]="column.icon">{{ column.icon }}</mat-icon>
          } @if (getColumnType(column) === 'button') {
          <button
            mat-icon-button
            [color]="column.icon ? 'primary' : 'accent'"
            (click)="column.action?.(row); $event.stopPropagation()"
          >
            <mat-icon>{{ column.icon || "more_vert" }}</mat-icon>
          </button>
          } @if (getColumnType(column) === 'menu') {
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation()"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            @for (item of column.menuItems; track item) {
            <button
              mat-menu-item
              (click)="item.action(row); $event.stopPropagation()"
              [disabled]="item.disabled?.(row)"
            >
              @if (item.icon) {
              <mat-icon>{{ item.icon }}</mat-icon>
              }
              <span>{{ item.label }}</span>
            </button>
            }
          </mat-menu>
          } @if (getColumnType(column) === 'image') {
          <img
            [src]="column.imageUrl"
            [style.width]="column.width"
            class="table-icon"
            alt="location"
          />
          } @if (getColumnType(column) === 'toggle') {
          <mat-slide-toggle
            [checked]="row.isActive"
            (change)="column.toggleAction?.(row, $event.checked)"
            (click)="$event.stopPropagation()"
            [color]="'primary'"
            [matTooltip]="row.isActive ? 'Active' : 'Inactive'"
          >
          </mat-slide-toggle>
          } }
        </td>
      </ng-container>
      }

      <!-- No Data Row -->
      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: stickyHeader"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          {{ noDataMessage }}
        </td>
      </tr>
    </table>

    <mat-paginator
      [length]="totalCount"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="showFirstLastButtons"
      (page)="onPageChange($event)"
    >
    </mat-paginator>

    <!-- Selection Summary -->
    @if (selectable && selectedRows.size > 0) {
    <div class="selection-summary">
      <span>{{ selectedRows.size }} items selected</span>
      <button mat-button color="warn" (click)="clearSelection()">
        <mat-icon>clear</mat-icon>
        Clear Selection
      </button>
    </div>
    }
  </div>
</div>
